const METRICA_ID = '34175205';
export { METRICA_ID };
